import { Badge, Tooltip, theme } from 'antd'

import { TRANSPORT_REQUEST_TEXTS as T } from './TransportRequest.types'

/**
 * Бейдж «Кількість пропозицій» біля статусу й на картці канбану (легасі
 * `TransformOffersCountTableColumnValueTask.jsx`, `RequestKanbanMode.jsx:95-100`).
 *
 * Число — `countOffers` запису (`SPEC-024`); поки пропозицій немає або бек
 * поля не віддає, бейджа немає зовсім. Колір — токен успіху теми, а не
 * вписаний зелений легасі: у темній темі він темніє разом з усім.
 */
export const OffersCountBadge = ({ count }: { count: unknown }) => {
    const { token } = theme.useToken()
    const value = typeof count === 'number' && Number.isFinite(count) ? count : 0

    if (value <= 0) return null

    return (
        <Tooltip title={T.offersCount}>
            <Badge count={value} style={{ backgroundColor: token.colorSuccess }} aria-label={T.offersCount} />
        </Tooltip>
    )
}
